import { RagChip } from "@/components/ui/rag";

export function ReportReadyOverview({ domains }) {
  return (
    <div className="overflow-hidden rounded-sm border border-border bg-card">
      <table className="w-full text-sm">
        <thead className="bg-muted/50">
          <tr className="text-left">
            <th className="px-4 py-3 font-mono-label text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Domain</th>
            <th className="px-4 py-3 font-mono-label text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Status</th>
            <th className="px-4 py-3 text-right font-mono-label text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Counts</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {domains.map((d) => (
            <tr key={d.key}>
              <td className="px-4 py-3 align-top">
                <div className="flex items-center gap-3">
                  <span className="letter-mark h-7 w-7 text-xs">{d.key}</span>
                  <span className="font-display text-[15px] font-medium text-foreground">
                    {d.title}
                  </span>
                </div>
              </td>
              <td className="px-4 py-3 align-top">
                <RagChip rag={d.rag} />
              </td>
              <td className="px-4 py-3 text-right text-xs text-muted-foreground">
                <span className="font-mono-label">
                  {d.counts.green || 0} green · {d.counts.amber || 0} amber · {d.counts.red || 0} red · {d.counts.na || 0} n/a
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
